<template>
  <div id="match-badge">
    <div class="details">
      <div id="icon"><img :src="iconSrc" alt="Automation icon" /></div>
      <div class="found">
        <span class="finder" data-test="finder">Found by {{ finder }}</span>
        <span class="result" data-test="result">{{ resultValue }}</span>
      </div>
    </div>
    <div class="action" @click="handleActionClick">
      <img :src="penSrc" alt="Change icon" />
      <a>{{ actionType }}</a>
    </div>
  </div>
</template>

<script>
import automationIcon from "@/images/Automation-gray.svg";
import penIcon from "@/images/edit.svg";

export default {
  name: "ChemSnapMatchBadge",
  data() {
    return {
      finder: "ChemSnap",
      iconSrc: automationIcon,
      actionType: "Change",
      penSrc: penIcon,
    };
  },
  props: {
    resultValue: { type: String, default: "" },
  },
  components: {},
  methods: {
    handleActionClick() {
      this.$emit("change-chemsnap-match", true);
    },
  },
};
</script>

<style scoped>
#match-badge {
  background-color: var(--blue-100);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  font-family: var(--font-system-ui);
  margin: 0.5rem 0;
  max-width: 80%;
}
.details {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
}
.found {
  display: flex;
  flex-direction: column;
}
.found .finder,
.action {
  color: var(--blue-1100);
}
.found .result {
  font-weight: bold;
  text-transform: uppercase;
}
.action {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 0.25rem;
}
.result {
  display: flex;
  flex-wrap: wrap;
}
</style>
